import { pedagogicalApproachParameters } from '../../../../../utils/defaultsProvider'
import StepMiniPedagogicalApproachService from '../services/stepMiniPedagogicalApproachService';
import USER_ROLES from "../../../../../constants/userRoles.constants";

class PedagogicalApproachController {
    /**
     * @param stepMiniPedagogicalApproachService
     * @param pedagogicalService
     * @param evaluationService
     * @param $state
     * @param $stateParams
     * @param $mdDialog
     * @param $timeout
     * @param $scope
     * @param $mdToast
     */
    constructor(
        stepMiniPedagogicalApproachService,
        pedagogicalService,
        evaluationService,
        learningAreaService,
        userService,
        $state,
        $stateParams,
        $mdDialog,
        $timeout,
        $scope,
        $mdToast,
        $q,
    ) {
        this.stepMiniPedagogicalApproachService = stepMiniPedagogicalApproachService;
        this.pedagogicalService = pedagogicalService;
        this.evaluationService = evaluationService;
        this.learningAreaService = learningAreaService;
        this.userService = userService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$mdDialog = $mdDialog;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$mdToast = $mdToast;
        this.$q = $q;

        this.export = {};
        this.isAdmin = false;
        this.isFinished = false;
        this.isAdmin = false;
        this.isManager = false;
        this.pedagogicalApproachParam = {};
        this.pedagogicalApproachParamHaxxor = [];
        this.subjectAreas = [];
        this.myScores = {};
        this.uploadError = {};
        this.averageScores = {};
        this.othersScores = [];
        this.state = 'parameters';
        this.instructions = '';
        this.stateChangeCheck = true;
        this.questions = [];
        this.param = { left: '', right: '' };
        this.skills = [{
            name: "Subject Area",
            id: -1,
            show: false,
            importances:[{
                level: 'A',
                skills: []
            },{
                level: 'B',
                skills: []
            },{
                level: 'N',
                skills: []
            }]
        }];
        this.currentActiveParameter = $stateParams.activeParameter;
    }

    $onInit() {
        const activeParameter = pedagogicalApproachParameters.find(e => e.index === +this.$stateParams.activeParameter);
        if (activeParameter) {
            this.pedagogicalApproachParam = activeParameter;
            this.pedagogicalApproachParamHaxxor[0] = activeParameter;
        } else {
            this.pedagogicalApproachParam = { name: "Unsupported parameter" };
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title("This pedagogical approach parameter is not supported")
                    .ok('OK')
            ).then(() => {
                this.$state.go(this.$state.current, { activeParameter: "1" }, { reload: false })
            }); //This then moves rogue users back to normal state
        }

        this.$q.all([
            this.pedagogicalService.getAllParameters(),
            this.pedagogicalService.getAllSkills(),
            this.learningAreaService.list()
        ]).then(res => {
            this.isAdmin = this.userService.isInRole(USER_ROLES.ROLE_ADMIN);
            this.questions = res[0].filter(param => param.parameter === this.pedagogicalApproachParam.name)
                .map(selectedParam => selectedParam.questions)
                .reduce((acc, val) => acc.concat(val), []);
            this.subjectAreas = res[1];
            this.learningAreas = res[2];
            this.learningAreas.forEach(learningArea => {
                this.skills.push({
                    name: learningArea.name,
                    id: learningArea.id,
                    show: false,
                    importances:[{
                        level: 'A',
                        skills: []
                    },{
                        level: 'B',
                        skills: []
                    },{
                        level: 'N',
                        skills: []
                    }]
                })
            });
            this.skills.sort((a, b) => a.id > b.id ? 1 : -1);
            this.prepareSkills();
        });
    }

    $onDestroy() {
        const shouldSaveScores = !angular.equals(this.myScores, this.myScoresPristine);
        const shouldSaveExports = !angular.equals(this.export, this.exportPristine);

        if (!this.isFinished && this.stateChangeCheck && shouldSaveScores) {
            this.handleNextButton(false);
        } else if (this.isFinished && this.stateChangeCheck && shouldSaveExports) {
            this.saveExportData(false);
        }

    }

    hideThisQuestion(question) {
        question.magnifyingGlass = null;
        question.pin = null;
    }

    prepareSkills() {
        this.evaluationService.getEvaluationData(this.$stateParams.id, true).then((data) => {
            this.isManager = data.isManager;
                this.param = data.publishSliders.length ? data.publishSliders[this.$stateParams.activeParameter - 1] : this.params;
            if(data.pedagogicalApproachesSummary) {
                this.export = data.pedagogicalApproachesSummary.find(y => y.parameterId === +this.$stateParams.activeParameter);
                this.export = this.export ? this.export : {};
            }

            data.learningGoals.forEach(learningGoal => {
                const foundSubjectArea = this.subjectAreas.find(area => area.id === learningGoal.areaId);
                if(foundSubjectArea) {
                    this.skills[0].show = true;
                    this.skills[0].importances.find(important => important.level === learningGoal.importance)
                        .skills.push(learningGoal);
                } else {
                    this.skills.find(area => {
                        if(area.id === learningGoal.areaId) {
                            area.show = true;
                            return true;
                        }
                    }).importances.find(important => important.level === learningGoal.importance)
                        .skills.push(learningGoal);
                }
                });

            const savedData = data.pedagogicalApproach.find(y => y.parameter === +this.$stateParams.activeParameter);
            this.savedData = savedData;
            const answers = savedData.answers;
            this.myScores.questions = this.questions.map(e => Object.assign({}, e, {
                hidden: answers ? (answers.find(z =>z.question.id === e.id) ?
                    answers.find(z =>z.question.id === e.id).hidden : false) : false,
                pin: answers ? (answers.find(z => z.question.id === e.id) ?
                    answers.find(z => z.question.id === e.id).pin : null) : null,
                magnifyingGlass: answers ? (answers.find(z => z.question.id === e.id) ?
                    answers.find(z => z.question.id === e.id).magnifyingGlass : null) : null,
                strength: answers ? (answers.find(z => z.question.id === e.id) ?
                    answers.find(z => z.question.id === e.id).strength : false) : false,
                developmentArea: answers ? (answers.find(z => z.question.id === e.id) ?
                    answers.find(z => z.question.id === e.id).developmentArea : false) : false
            }));
            this.myScores.summary = {
                strengths: savedData.strengths ? savedData.strengths : '',
                developmentAreas: savedData.developmentAreas ? savedData.developmentAreas : '',
                strengthsImage: savedData.strengthsImage ? savedData.strengthsImage : '',
                developmentAreasImage: savedData.developmentAreasImage ? savedData.developmentAreasImage : ''
            };
            this.myScoresPristine = JSON.parse(angular.toJson(this.myScores));
            this.exportPristine = JSON.parse(angular.toJson(this.export));

            if (this.evaluationService.isAfterFinish(data.status)) {
                this.isFinished = true;
                this.evaluationService.getOthers('pedagogical_approaches', data.isMini, data.id).then((othersData) => {
                    this.othersScores = othersData;

                    this.othersScores.forEach(other => {
                        const otherSavedData = other.pedagogicalApproaches.find(y => y.parameter === +this.$stateParams.activeParameter);
                        other.questions = this.questions.map(e => Object.assign({}, e, {
                            hidden: otherSavedData.answers ? (otherSavedData.answers.find(z =>z.question.id === e.id) ?
                                otherSavedData.answers.find(z =>z.question.id === e.id).hidden : false) : false,
                            pin: otherSavedData.answers ? (otherSavedData.answers.find(z => z.question.id === e.id) ?
                                otherSavedData.answers.find(z => z.question.id === e.id).pin : null) : null,
                            magnifyingGlass: otherSavedData.answers ? (otherSavedData.answers.find(z => z.question.id === e.id) ?
                                otherSavedData.answers.find(z => z.question.id === e.id).magnifyingGlass : null) : null,
                            strength: otherSavedData.answers ? (otherSavedData.answers.find(z => z.question.id === e.id) ?
                                otherSavedData.answers.find(z => z.question.id === e.id).strength : false) : false,
                            developmentArea: otherSavedData.answers ? (otherSavedData.answers.find(z => z.question.id === e.id) ?
                                otherSavedData.answers.find(z => z.question.id === e.id).developmentArea : false) : false
                        }));
                        other.summary = {
                            strengths: otherSavedData.strengths,
                            developmentAreas: otherSavedData.developmentAreas,
                            strengthsImage: otherSavedData.strengthsImage ? otherSavedData.strengthsImage : '',
                            developmentAreasImage: otherSavedData.developmentAreasImage ? otherSavedData.developmentAreasImage : ''
                        };
                    });

                });
            }
        });
    }

    gotoTab(paramIndex) {
        this.$state.go(this.$state.current, { activeParameter: paramIndex }, { reload: false });
    }

    isCurrentGoal(paramIndex) {
        return paramIndex === +this.$stateParams.activeParameter;
    }

    drawScoreRuler(id, score) {
        this.$timeout(() => {
            const rulerLength = 210;
            const rulerOffset = 20;

            const canvas = document.getElementById(id);
            if (!canvas) {
                return;
            }

            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height); //clear previous drawing
            ctx.fillStyle = '#d6e0e5';
            ctx.fillRect(rulerOffset, 20, rulerLength, 10);
            ctx.fillRect(rulerOffset, 12, 3, 10);
            ctx.fillRect(rulerOffset + rulerLength - 3, 12, 3, 10);

            ctx.fillStyle = 'black';
            ctx.textAlign = 'center';
            const textStart = '-' + score.range;
            ctx.fillText(textStart, rulerOffset, 10);
            const textEnd = score.range;
            ctx.fillText(textEnd, rulerLength + rulerOffset, 10);

            const step = rulerLength / (2 * score.range);
            const drawGlass = (color) => {
                // draw Glass
                const glassPosition = step * (score.sumGlass + score.range) + rulerOffset;
                ctx.fillStyle = '#000000';
                ctx.fillText(score.sumGlass, glassPosition, 10);
                ctx.lineWidth = 2;
                ctx.beginPath();
                ctx.arc(glassPosition, 24, 8, 0, 2 * Math.PI);
                ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
                ctx.fill();
                ctx.strokeStyle = color;
                ctx.stroke();

                //draw Glass line
                ctx.beginPath();
                ctx.moveTo(glassPosition + 5, 29);
                ctx.lineTo(glassPosition + 10, 35);
                ctx.stroke();
            };
            const drawPin = () => {
                //draw Pin
                const pinPosition = step * (score.sumPin + score.range) + rulerOffset;
                ctx.fillText(score.sumPin, pinPosition, 10);
                ctx.beginPath();
                ctx.arc(pinPosition, 21, 4, 0, 2 * Math.PI);
                ctx.fillStyle = '#ff9900';
                ctx.fill();
                ctx.strokeStyle = '#ff9900';
                ctx.stroke();

                //draw Pin line
                ctx.beginPath();
                ctx.moveTo(pinPosition, 24);
                ctx.lineTo(pinPosition, 32);
                ctx.stroke();
            };
            if (score.sumGlass === score.sumPin) {
                drawGlass('#ff9900');
                return;
            }
            if (score.sumPin !== null) {
                drawPin();
            }
            if (score.sumGlass !== null) {
                drawGlass('#003459');
            }
        });
    }

    isNotNull(value) {
        return !Number.isNaN(value) && value !== null;
    }

    updateScore(score) {
        let deviation = 0;
        let maxDeviation = 0;
        let sumGlass = 0;
        let sumPin = 0;
        const pinsDefined = score.questions.some(q => q.pin !== null);
        const glassDefined = score.questions.some(q => q.magnifyingGlass !== null);
        score.questions.forEach((question) => {
            if (this.isNotNull(question.magnifyingGlass) || this.isNotNull(question.pin)) {
                maxDeviation += 4;
                if (this.isNotNull(question.magnifyingGlass) && this.isNotNull(question.pin)) {
                    deviation += Math.abs(question.magnifyingGlass - question.pin);
                }
                if (this.isNotNull(question.magnifyingGlass)) {
                    sumGlass += question.magnifyingGlass;
                }
                if (this.isNotNull(question.pin)) {
                    sumPin += question.pin;
                }
            }
        });

        score.range = maxDeviation / 2;
        score.currentScore = (maxDeviation !== 0 ? ((1 - deviation / maxDeviation) * 100) : '-');
        score.sumGlass = glassDefined ? sumGlass : null;
        score.sumPin = pinsDefined ? sumPin : null;
    }

    switchToResults() {
        this.updateScore(this.myScores);
        this.drawScoreRuler('ruler_', this.myScores);
        if(this.isFinished) {
            const mySumGlassVar = this.myScores.range > 0 ? (this.myScores.sumGlass/this.myScores.range) : 0;
            const mySumPinVar = this.myScores.range > 0 ? (this.myScores.sumPin/this.myScores.range) : 0;

            this.averageScores = {...this.myScores};
            this.othersScores.forEach((other, index) => {
                this.updateScore(other);
                this.averageScores.range = this.averageScores.range < other.range ? other.range : this.averageScores.range;
                this.drawScoreRuler('ruler_' + index, other);
            });
            const allEvaluationsCount = this.othersScores.filter(other => other.range > 0).length + (this.myScores.range > 0 ? 1 : 0);

            if(allEvaluationsCount) {
                this.evaluationService.getPARulersAvgScores(this.$stateParams.id).then((data) => {
                    const result = data[this.$stateParams.activeParameter];
                    this.averageScores.currentScore = result.score;
                });
                this.averageScores.sumGlass = Math.round((this.othersScores.reduce(function (previousResult, currentOther) {
                    return currentOther.range > 0 ? (previousResult + (currentOther.sumGlass / currentOther.range)) : previousResult;
                }, 0) + mySumGlassVar) / allEvaluationsCount * this.averageScores.range);

                this.averageScores.sumPin = Math.round((this.othersScores.reduce(function (previousResult, currentOther) {
                    return currentOther.range > 0 ? (previousResult + (currentOther.sumPin / currentOther.range)) : previousResult;
                }, 0) + mySumPinVar) / allEvaluationsCount * this.averageScores.range);
            }
            this.drawScoreRuler('ruler_Average', this.averageScores);
        }

        this.state = 'results';
    }

    onPictureUpload(file, obj, field) {
        this.evaluationService.convertImageToBase64(file)
            .then((res) => {
                if (res) {
                    this.uploadError[field] = null;
                    obj[field] = res.replace(/^.+base64,/, '');
                }
            })
            .catch((error) => {
                this.uploadError[field] = error.status;
            });
    }

    copyInstruction(question, changedField) {
        if(changedField === 'strength') {
            if(question.strength) {
                this.myScores.summary.strengths += question.text + '\n';
            } else {
                this.myScores.summary.strengths = this.myScores.summary.strengths.replace(question.text + '\n', '');
            }
        } else if(changedField === 'developmentArea') {
            if(question.developmentArea) {
                this.myScores.summary.developmentAreas += question.text + '\n';
            } else {
                this.myScores.summary.developmentAreas =
                    this.myScores.summary.developmentAreas.replace(question.text + '\n', '');
            }
        }
    }

    saveExportData(redirect) {
        const emptyExport = {
            strengths: '',
            strengthsImage: '',
            developmentAreas: '',
            developmentAreasImage: ''
        };

        this.stepMiniPedagogicalApproachService.saveExportData(
            { ...emptyExport, ...this.export, 'parameterId': this.savedData.parameter },
            this.$stateParams.id,
        ).then(() => {
            this.executeRedirect(redirect);
        });
    }

    handleNextButton(redirect) {
        this.myScores.summary.strengthsImage = this.myScores.summary.strengthsImage &&
            this.myScores.summary.strengthsImage.indexOf('api/uploads') === -1 ? this.myScores.summary.strengthsImage : null;
        this.myScores.summary.developmentAreasImage = this.myScores.summary.developmentAreasImage &&
            this.myScores.summary.developmentAreasImage.indexOf('api/uploads') === -1 ? this.myScores.summary.developmentAreasImage : null;

        this.stepMiniPedagogicalApproachService.saveDataConfig(
            this.myScores.questions,
            this.myScores.summary,
            { activeParameter: this.currentActiveParameter },
        ).then(() => {
            this.executeRedirect(redirect);
        });
    }

    executeRedirect(redirect) {
        const currentIndex = pedagogicalApproachParameters.findIndex(e => e.index === +this.$stateParams.activeParameter);
        this.stateChangeCheck = false;

        if (redirect) {
            if (currentIndex === pedagogicalApproachParameters.length - 1) {
                this.$state.go(`mini.learningEngagement.aspect`, {
                    id: this.$stateParams.id,
                    aspectNr: 0,
                    reload: false
                });
            } else {
                this.$state.go(this.$state.current, {
                    id: this.$stateParams.id,
                    activeParameter: pedagogicalApproachParameters[currentIndex + 1].index,
                    reload: false
                });
            }
        }
    }
}

PedagogicalApproachController.$inject = [
    'StepMiniPedagogicalApproachService',
    'PedagogicalService',
    'EvaluationService',
    'LearningAreaService',
    'UserService',
    '$state',
    '$stateParams',
    '$mdDialog',
    '$timeout',
    '$scope',
    '$mdToast',
    '$q'
];

export default PedagogicalApproachController;


// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepMiniPedagogicalApproach/singleParameterView/pedagogicalApproachParameterController.js